<template>
  <AnalyticsDecimalPrecisions />
  <AnalyticsAssetTree />
</template>

<script setup lang="ts">
import AnalyticsAssetTree from './AnalyticsAssetTree.vue'
import AnalyticsDecimalPrecisions from './AnalyticsDecimalPrecisions.vue'

defineOptions({ name: 'AnalyticsSettings' })
</script>
